import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QuestionReviewTaskCreationButton,
  QuestionReviewStatusFilter,
  QuestionReviewTaskList,
} from '@exam-management/question-review-task-list';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function QuestionReviewPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.TASK.QUESTION_REVIEW.VIEW}>
      <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
        <PaperSection
          title='Question Review'
          endAdornment={
            <WithPermission
              requiredPermission={[
                APP_PERMISSIONS.TASK.QUESTION_REVIEW.CREATE,
                APP_PERMISSIONS.QBANK.QUESTION.VIEW,
                APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
                APP_PERMISSIONS.SETTING.USER.VIEW,
              ]}
            >
              <QuestionReviewTaskCreationButton />
            </WithPermission>
          }
          sx={{ flexGrow: 1 }}
        >
          <Flex
            sx={(theme) => ({
              m: theme.spacing(6),
              flexDirection: 'column',
              border: `1px solid ${theme.palette.grey[300]}`,
              borderRadius: theme.shape.rounded(2),
              height: '100%',
              overflow: 'hidden',
            })}
          >
            <QuestionReviewStatusFilter />
            <QuestionReviewTaskList />
          </Flex>
        </PaperSection>
      </Flex>
    </PermissionGuard>
  );
}
